import React from 'react';
import { IIcon } from './../../@types/icons';

export function CircleCheckedbox ({ size = 16 }: IIcon) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 16 16"
    >
      <rect width="16" height="16" fill="#58C3BB" rx="8" />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M5 8.222 6.846 10 11 6"
      />
    </svg>
  );
}
